import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ModalContent } from '@src/shared/modal/confirm-modal/confirm-modal.type';
import { ModalService } from '@src/shared/modal/modal.service';
import { CampaignService } from '../../../../woo_services.module/CampaignService';
import { RoutingService } from '../../../../woo_services.module/RoutingService';
import { Campaign, CampaignStatus } from '../../../../woo_services.module/shared-types';

@Component({
  selector: 'remove-campaign-button',
  template: ` <text-button icon="trash" [disabled]="disabled" (click)="onClick()"> Ta bort </text-button> `,
  standalone: false,
})
export class RemoveCampaignButton {
  @Input() campaign: Campaign;
  @Input() disabled = false;

  constructor(
    private campaignService: CampaignService,
    private routingService: RoutingService,
    private modalService: ModalService,
  ) {}

  onClick = (): void => {
    if (this.disabled) {
      return;
    }

    const content = this.getDialogContent();
    this.modalService.openConfirm(content).then(
      (response) => {
        if (response.confirm) {
          this.removeCampaign(this.campaign);
        }
      },
      () => null,
    );
  };

  private removeCampaign = (campaign: Campaign) => {
    if (this.campaignService.hasAnyStatus(campaign, [CampaignStatus.unbooked])) {
      this.removeUnbooked(campaign);
    } else if (
      this.campaignService.hasAnyStatus(campaign, [
        CampaignStatus.cancelled,
        CampaignStatus.ended,
        CampaignStatus.stopped,
      ])
    ) {
      this.removeEnded(campaign);
    } else {
      const msg = 'Endast obokade, avslutade eller stoppade kanpanjer kan tas bort.';
      this.modalService.openError(msg);
    }
  };

  private removeUnbooked = (campaign: Campaign) => {
    this.campaignService
      .removeUnbooked(campaign.id)
      .then(
        () => {
          this.removeSuccess();
        },
        (reason) => {
          this.removeFailure(reason);
        },
      )
      .catch(() => {
        this.removeError();
      });
  };

  private removeEnded = (campaign: Campaign) => {
    this.campaignService
      .removeEnded(campaign.id)
      .then(
        () => {
          this.removeSuccess();
        },
        (reason) => {
          this.removeFailure(reason);
        },
      )
      .catch(() => {
        this.removeError();
      });
  };

  private removeSuccess = (): void => {
    this.modalService.openSuccess('Kampanjen har tagits bort.');
    this.routingService.navigateWithReload(['/dashboard']);
  };

  private removeFailure = (reason): void => {
    if (!(reason instanceof HttpErrorResponse)) {
      const msg = 'Ajdå, något gick snett. Din kampanj kunde inte tas bort.';
      this.modalService.openError(msg);
    }
  };

  private removeError = (): void => {
    const msg = 'Ajdå, nånting gick snett. Testa att refresha browsern och försök igen.';
    this.modalService.openError(msg);
  };

  private getDialogContent = (): ModalContent => ({
    title: 'Ta bort kampanj',
    texts: [`Är du säker på att du vill ta bort <strong>${this.campaign.name}</strong>?`],
    confirmLabel: 'Ta bort kampanj',
    cancelLabel: 'Avbryt',
  });
}
